import Vue from 'vue';
import App from '@/App.vue';
import router from '@/router';
import '@/plugins/quasar';
import '@/util/polyfills';
import '@/styles/index.scss';
import WebCenterIframeResizer from 'mmm-webcenter-iframe-resizer';
import Axios from 'axios';
import store from './store/store';
import 'flag-icon-css/css/flag-icon.css';
import { mapMutations } from 'vuex';

Vue.config.productionTip = false;

new Vue({
    data: {
        ready: false,
        loadingBarTimeout: null,
        activeElement: null,
        currencies: [],
    },
    watch: {
        $route() {
            this.scrollToTop();
        },
        '$q.loading.isActive'(value) {
            clearTimeout(this.loadingBarTimeout);
            if (value) {
                this.activeElement = window.document.activeElement;
                if (this.activeElement) {
                    this.activeElement.blur();
                }

                this.loadingBarTimeout = setTimeout(() => {
                    window.document.querySelector('.q-loading').classList.add('active');
                    this.$q.loadingBar.start();
                }, 750);
            } else {
                this.$q.loadingBar.stop();
                if (this.activeElement) {
                    this.activeElement.focus();
                }
            }
        },
    },
    async mounted() {
        WebCenterIframeResizer.init();

        await this.fetchCurrencies();

        this.ready = true;
    },
    methods: {
        ...mapMutations([
            'setCurrencies',
        ]),
        scrollToTop() {
            if (this.$q.platform.within.iframe) {
                WebCenterIframeResizer.resizeFrame(0);
            }
        },
        notify(message, color = 'info', position = 'top') {
            this.$q.notify({
                color,
                textColor: `${color}-invert`,
                message,
                position,
                actions: [{ icon: 'fal fa-times', color: `${color}-invert` }],
            });
        },
        handleError(error) {
            this.$q.notify({
                message: error.response?.data?.title ?? error.response?.data?.['hydra:title'] ?? 'Es ist ein Fehler aufgetreten',
                caption: error.response?.data?.detail ?? error.response?.data?.['hydra:description'] ?? null,
                color: 'negative',
                textColor: 'negative-invert',
                position: 'top',
                actions: [{ icon: 'fal fa-times', color: 'negative-invert' }],
            });
        },
        async fetchCurrencies() {
            const res = await Axios.get('/api/currencies');
            this.currencies = res.data;

            //Rename currency code CNY to CNH - customer request
            for(let key in this.currencies) {
                if(this.currencies[key].code === 'CNY') {
                    this.currencies[key].code = 'CNH';
                }
            }
            await this.$store.dispatch('setCurrencies', this.currencies);
            let topCurrency = this.getTopCurrency();
            this.$store.dispatch('setTopCurrency', topCurrency);
        },
        getTopCurrency() {
            let topCurrency = {};
            this.currencies.forEach((currency) => {
                if(currency.top) {
                    topCurrency = currency;
                }
            });
            return topCurrency;
        },
    },
    store: store,
    router,
    render: h => h(App),
}).$mount('#app');
